import "features/excelDiff/pages/ExcelDiffPage.css";

import React, {memo, useMemo} from "react";
import {AgGridReact} from 'ag-grid-react';
import {
    ColDef,
    ColGroupDef,
    GridOptions,
    themeQuartz,
    ValueGetterParams,
    ModuleRegistry,
    RowStyleModule,
    CellStyleModule,
    TextFilterModule,
    NumberFilterModule,
    CustomFilterModule,
    ClientSideRowModelModule,
} from 'ag-grid-community';
import {
    SetFilterModule,
    MultiFilterModule,
} from 'ag-grid-enterprise';

import {PVRDocType, PVRRow} from "../types";
import {cellFormatter, computeColumnSizes, DocumentLinkComponent, ProductLinkComponent} from "shared/components/table";

ModuleRegistry.registerModules([
    RowStyleModule,
    CellStyleModule,
    TextFilterModule,
    NumberFilterModule,
    CustomFilterModule,
    ClientSideRowModelModule,
    SetFilterModule,
    MultiFilterModule,
]);

const columns = ['Row', 'Reason', 'Document', 'Text Type', 'Document Text', 'collection', 'name'];


const PVRTable = ({result, selectedDoc}: { result: PVRRow[], selectedDoc: PVRDocType }) => {
    const columnSizes = useMemo(() => computeColumnSizes(columns, result.filter(r => r.docType === selectedDoc)), [result, selectedDoc]);

    const colDefs: (ColDef<any, any> | ColGroupDef<any>)[] = useMemo(() => { return [
        {
            headerName: "Row",
            valueGetter: (p: ValueGetterParams) => p.data.Row + ', ' + p.data.URL,
            cellRenderer: ProductLinkComponent,
            filter: false,
            comparator: (valueA, valueB) => valueA.split(', ')[0] - valueB.split(', ')[0],
            flex: columnSizes['Row']
        },
        {
            field: 'Reason',
            valueFormatter: cellFormatter,
            filter: true,
            flex: columnSizes['Reason'],
        },
        {
            headerName: selectedDoc,
            valueGetter: (p: ValueGetterParams) => p.data.Document,
            cellRenderer: DocumentLinkComponent,
            filter: true,
            flex: columnSizes["Document"]
        },
        ...(selectedDoc === 'imageFile'? [] : [
            {
                field: 'Text Type',
                valueFormatter: cellFormatter,
                filter: true,
                flex: columnSizes['Text Type'],
            },
            {
                headerName: selectedDoc.slice(0, -5)+' Text',
                valueGetter: (p: ValueGetterParams) => p.data['Document Text'],
                valueFormatter: cellFormatter,
                filter: true,
                flex: columnSizes['Document Text'],
            },
        ]),
        {
            field: 'collection',
            valueFormatter: cellFormatter,
            filter: true,
            flex: columnSizes['collection'],
        },
        {
            field: 'name',
            valueFormatter: cellFormatter,
            filter: true,
            flex: columnSizes['name'],
        },
    ]}, [columnSizes, selectedDoc]);

    const tableTheme = themeQuartz.withParams({
        spacing: 3,
        foregroundColor: 'white',
        backgroundColor: '#27374D',
        headerBackgroundColor: '#354A5F',
        rowHoverColor: '#496F87',
    });

    const gridOptions: GridOptions =  {
        defaultColDef: {
            flex: 1,
            sortable: true,
            filter: true,
        },
        enableFillHandle: true,
        enableCellTextSelection: true,
        suppressHorizontalScroll: false,
    };

    return (
        <div className="excel-table-container scrollable" style={{width: columnSizes['generalLength']*7}}>
            <AgGridReact
                rowData={result.filter(r => r.docType === selectedDoc)}
                columnDefs={colDefs}
                gridOptions={gridOptions}
                theme={tableTheme}
              />
        </div>
    );
}

export default memo(PVRTable);